import { ResourceExplorerDynamicFilterItemType } from "@/services/cloudchipr.api";

export const filterTypeWithAsyncSearch =
  new Set<ResourceExplorerDynamicFilterItemType>([
    "resource_id",
    "resource_group",
  ]);

export const filterTypeWithBatchValues =
  new Set<ResourceExplorerDynamicFilterItemType>([
    "tag",
    "resource_id",
    "parent_resource_id",
  ]);
